export const dump = (...args) => {
  if (process.env.REACT_APP_DEBUG === 'true') {
    const date = new Date()
    console.log(
      `%c${date.getHours()}:${date.getMinutes()} DEBUG INFORMATION: (${window.location.pathname})%c\n`,
      'color: LightSeaGreen; font-weight: bold; background-color: LightCyan; display: block; padding: 4px; margin-bottom: 4px;',
      'display: block',
      ...args,
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/debugService.js